module.exports = __webpack_public_path__ + "img/Demo Virtual Event.10e6edcd.png";